import React from "react";
import { Link } from "react-router-dom";
// import 'bootstrap/dist/css/bootstrap.min.css';

const DataTableFooter = ({ dataT }) => {
  return (
    <div className="flex flex-col md:flex-row justify-between items-center py-3 text-dark">
      {/* Showing Entries Section */}
      <div className="mb-2 md:mb-0">
        Showing 1 to {dataT.length} of {dataT.length} entries
      </div>

      {/* Pagination Section */}
      <div className="flex" id="timetracker-table_paginate">
        <ul className="flex mb-0">
          {/* Previous Button */}
          <li className="paginate_button page-item previous ">
            <Link
              to="/"
              aria-controls="timetracker-table"
              className="page-link text-primary px-3 py-2 bg-primary-100 rounded rounded-e-none"
            >
              Previous
            </Link>
          </li>

          {/* Page Number */}
          <li className="paginate_button page-item active">
            <Link
              to="/"
              aria-controls="timetracker-table"
              className="page-link text-white bg-primary px-4 py-2"
            >
              1
            </Link>
          </li>

          {/* Next Button */}
          <li className="paginate_button page-item next">
            <Link
              to="/"
              aria-controls="timetracker-table"
              className="page-link text-primary px-3 py-2 bg-primary-100 rounded rounded-s-none"
            >
              Next
            </Link>
          </li>
        </ul>
      </div>
    </div>

  );
};

export default DataTableFooter;
